module.exports = __webpack_public_path__ + "img/yfood-cold-brew-coffee.c6ab0414.png";